import { useEffect } from 'react';

function AssessmentSection({ 
  section, 
  answers, 
  onAnswer, 
  onNext, 
  onPrevious, 
  isLastSection,
  onSubmit 
}) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [section.id]);

  const ratings = [
    { value: 1, label: 'Strongly Disagree' },
    { value: 2, label: 'Disagree' },
    { value: 3, label: 'Neutral' },
    { value: 4, label: 'Agree' },
    { value: 5, label: 'Strongly Agree' }
  ];

  const isComplete = section.questions.every((_, index) => 
    answers[`${section.id}-${index}`]
  );

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Part {section.id}: {section.title}
        </h2>
        <div className="bg-primary-50 border-l-4 border-primary p-4 rounded">
          <p className="text-primary-900">
            {section.description}
          </p>
        </div>
      </div>

      <div className="space-y-8">
        {section.questions.map((question, index) => (
          <div key={index} className="bg-gray-50 p-4 rounded-lg space-y-4">
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <span className="flex items-center justify-center w-7 h-7 rounded-full bg-gray-200 text-gray-700 font-semibold text-sm">
                  {index + 1}
                </span>
              </div>
              <p className="text-gray-800 font-medium text-sm">{question}</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-5 gap-1.5 pl-11">
              {ratings.map(rating => {
                const isSelected = answers[`${section.id}-${index}`] === rating.value;
                return (
                  <button
                    key={rating.value}
                    onClick={() => onAnswer(section.id, index, rating.value)}
                    className={`px-2 py-1.5 rounded text-xs transition-colors text-center whitespace-nowrap border
                      ${isSelected 
                        ? 'bg-primary-100 text-primary-800 border-primary-200'
                        : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-200'
                      }`}
                  >
                    {rating.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 flex justify-between">
        <button
          onClick={onPrevious}
          className="w-28 px-6 py-2 text-gray-600 hover:text-gray-900"
        >
          Previous
        </button>
        
        {isLastSection ? (
          <button
            onClick={onSubmit}
            disabled={!isComplete}
            className={`w-28 px-6 py-2 rounded-md
              ${isComplete 
                ? 'bg-primary text-white hover:bg-primary-600'
                : 'bg-gray-200 text-gray-500 cursor-not-allowed'
              }`}
          >
            Submit
          </button>
        ) : (
          <button
            onClick={onNext}
            disabled={!isComplete}
            className={`w-28 px-6 py-2 rounded-md
              ${isComplete 
                ? 'bg-primary text-white hover:bg-primary-600'
                : 'bg-gray-200 text-gray-500 cursor-not-allowed'
              }`}
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
}

export default AssessmentSection; 